import React from "react";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import Screen from "./page/screen";

import "./assets/scss/themes.scss";

Loading.init({
  backgroundColor: "rgba(239, 239, 239, 0.8)",
  svgSize: "100px",
  svgColor: "#5d5b53",
  messageColor: "#5d5b53",
  messageFontSize: "24px",
  fontFamily: "Noto Sans TC",
  clickToClose: false,
  zindex: 20000
});

function App() {
  return (
    <React.Fragment>
      <Screen />
    </React.Fragment>
  );
}

export default App;
